export default __webpack_public_path__ + "navigation-overview-quickstart-result-960-7fbf054c0f78ad17a9620f96996645a6.png";